import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'

export let startLTIFailedLogin = () => {
  ReactDOM.render(<App />, document.getElementById('ltiFailedLoginApp'))
}
